export const addQuestion = question => ({ type: 'ADD_QUESTION', question })
export const addQuestions = questions => ({ type: 'ADD_QUESTIONS', questions })
export const removeQuestion = id => ({ type: 'REMOVE_QUESTION', id })

export const clearQuestions = () => ({ type: 'CLEAR_QUESTIONS' })
